import React from "react";
import { useState, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';

import SearchBar from "./common/SearchBar";

import axios_api from "../Api";
import { API_URL, AUTH_TOKEN } from '../Context';


export default function TaskCreate(){

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();

  const [labs, setLabs] = useState([])
  const [forms, setForms] = useState([])
  const [samples, setSamples] = useState([])

  const [taskData, setTaskData] = useState({deadline_date: '2025-12-20', samples: {}})
  const [formSampleLiterals, setFormSampleLiterals] = useState([])

  const [formError, setFormError] = useState(false)

  React.useEffect(() => {

    let labs = axios_api.get(api_url + '/users/', {
      headers: {"Authorization": token},
    });
    let forms = axios_api.get(api_url + '/forms/', {
      headers: {"Authorization": token}
    });
    let samples = axios_api.get(api_url + '/samples/', {
      headers: {"Authorization": token}
    });

    labs.then(
      (result) => {
        let apiReturnedLabs = result.data  
        setLabs(apiReturnedLabs);
      },
      (error) => {console.log(error)}
    );

    forms.then(
      (result) => {
        let apiReturnedForms = result.data  
        setForms(apiReturnedForms);
      },
      (error) => {console.log(error)}
    );

    samples.then(
      (result) => {
        let apiReturnedSamples = result.data  
        setSamples(apiReturnedSamples);
      },
      (error) => {console.log(error)}
    );

  }, []);


  function SampleSelectField({literal}) {
    //console.log(literal)

    let sampleNumberInForm = literal[0];
    let sampleLiteral = literal[1];

    return (
      <div className="input-group ms-5 my-3">
        <label className="mt-3">
          <p>связанный образец: {sampleNumberInForm + ', ' + sampleLiteral}</p>
          {taskData.samples[sampleNumberInForm] ?
            <select id={sampleNumberInForm} className="lk-select form-select" value={taskData.samples[sampleNumberInForm]} onChange={handleChangeSample}>
              {sampleRows}
            </select> 
          :
            <select id={sampleNumberInForm} className="lk-select form-select" value="" onChange={handleChangeSample}>
              <option select disabled value="">- выбрать - </option>
              {sampleRows}
            </select> 
          }
        </label>
      </div>
    )
  }


  const handleChange = (event) => {

    let name = event.target.id;
    let value = event.target.value;
    let taskDataNext = structuredClone(taskData);
    taskDataNext[name] = value;

    setTaskData(taskDataNext);
  };

  const handleChangeForm = (event) => {

    let taskDataNext = structuredClone(taskData);
    taskDataNext['form'] = Number(event.target.value);
    taskDataNext['samples'] = {};

    for (let i in forms) {
      if(forms[i].id === Number(event.target.value)) {
        if(forms[i].samples_numbers_and_literals && forms[i].samples_numbers_and_literals.length > 0 ) {
          setFormSampleLiterals(forms[i].samples_numbers_and_literals);
        } else {
          setFormSampleLiterals();
        }
        break;
      }
    }
    
    //console.log('handleChangeForm: ', taskDataNext)
    //alert('handleChangeForm: ')

    setTaskData(taskDataNext);
  };

  const handleChangeSample = (event) => {

    let name = event.target.id;
    let value = event.target.value;

    //console.log(name)
    //console.log(value)
    //alert('HANDLE SAMPLE 1')

    console.log('TASK DATA: ', taskData)
    let taskDataNext = structuredClone(taskData);

    taskDataNext.samples[name] = value

    //console.log(taskDataNext)
    //alert('HANDLE SAMPLE 2')

    setTaskData(taskDataNext);
  };


  const handleSubmit = (event) => {
    event.preventDefault(); // Предотвращаем перезагрузку страницы
   
    axios_api.post(api_url + `/manage_task/`, taskData, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        console.log("Task created");
        navigate("/");
        navigate(0);
      },
      (error) => {
        setFormError(error.response.data)
        console.log(error);
      }
    );
  }

  let labRows = [];
  for (let i in labs) {
    labRows.push(
      <option key={i} value={labs[i].username}>{labs[i].username}</option>
    )
  }

  let formRows = [];
    for (let i in forms) {
    formRows.push(
      <option key={i} value={forms[i].id}>{forms[i].name}</option>
    )
  }

  let sampleRows = [];
  for (let i in samples) {
    sampleRows.push(
      <option key={i} value={samples[i].sample_code}>пул {samples[i].pool} - образец {samples[i].sample_code}</option>
    )
  }


  let formSampleSelectFields = [];
  for (let literal in formSampleLiterals) {
    formSampleSelectFields.push(
      <SampleSelectField 
        key={literal}
        literal={formSampleLiterals[literal]}
      />
    )
  }

  return (
    <>
      <div className="row">
        <h3 className="m-3">Создать Задание</h3>
      </div>
      <div className='row'>
        <div className="col-5 ms-3 lk-form">
          <form onSubmit={handleSubmit}>
            <div className="input-group my-3">
              <label className="mt-3">
                <p>лаборатория</p>
                  {taskData.lab ?
                    <select id="lab" className="lk-select form-select" value={taskData.lab} onChange={handleChange}>
                      {labRows}
                    </select> 
                  :
                    <select id="lab" className="lk-select form-select" value="" onChange={handleChange}>
                      <option select disabled value=""> - выбрать - </option>
                      {labRows}
                    </select> 
                  }
              </label>
            </div>

            <div className="input-group my-3">
              <label className="mt-3">
                <p>форма</p>
                  {taskData.form ?
                    <select id="form" className="lk-select form-select" value={taskData.form} onChange={handleChangeForm}>
                      {formRows}
                    </select> 
                  :
                    <select id="form" className="lk-select form-select" value="" onChange={handleChangeForm}>
                      <option select disabled value="">- выбрать - </option>
                      {formRows}
                    </select> 
                  }
              </label>
            </div>

            { formSampleSelectFields.length > 0 ?
              <>
                {formSampleSelectFields}
              </>
            :
              <></>
            }
            <div className="input-group my-3">  
              <label className="mt-3">
                <p>Дата представления результатов</p>
                <input id="deadline_date" type="text" className="form-control" value={taskData.deadline_date} onChange={handleChange}/>
              </label>
            </div>

            { formError &&
              <p className="text-danger">{formError}</p>
            }
            
            <button type="submit" className="btn lk-button my-3">Создать</button>

          </form>
        </div>               
      </div> 
    </>
  )
}
